<script>
    import Reviews from "../components/Reviews.svelte";
    import reviewsdata from "../utils/reviewsdata";
    export let bg = '';

</script>

<div class="image-background">
    <h1 class="header_text_wrapper text-left"><span>Mangomist Reviews</span><span class="separator"></span></h1>
</div>
<div class="d-flex flex-wrap reviews-page">
    {#each reviewsdata as item}
        <Reviews bg={bg} reviewcode={item.reviewcode} reviewrname={item.reviewrname} 
        reviewdate={item.reviewdate} description={item.description} ratingnumber={item.ratingnumber} />
    {/each}
</div>
<style>
    
    .image-background {
        background: url("../images/Reviews-1.jpg") no-repeat center;
    }

</style>